<template>
  <div>
     <UserSide
      :allDocuments="documents"
      :sideOpen="userSideOpen"
      :user="selectedUser"
      @updateUser="updateUser($event, 'deactivation_date')"
      @closeSide="userSideOpen = false"
    />
    <div ref="dashboard" class="superset-embed-container"></div>
  </div>
</template>

<script>
// import { embedDashboard } from "@superset-ui/embedded-sdk";
import UserSide from "@/components/layout/users/UserSide";

import axios from "axios";
export default {
    components:{
        UserSide
    },
    data(){
        return{
            supersetIframe: null,
            embedDashboard: null,
            userSideOpen: false,
            selectedUser: {},
            documents: [],
        }
    },
    mounted(){
        // this.embed()
        if (this.$store.state.user_role == "admin") {
            this.getDocuments();
        }
    },
    beforeDestroy(){
    },
    methods:{
        async embed(){
           this.embedDashboard = await embedDashboard({
            id: "24a09e47-beee-4bbc-af05-fe531586a82c", // given by the Superset embedding UI
            supersetDomain: "https://dashboards.lkakademija.lt",
            mountPoint: this.$refs.dashboard, // any html element that can contain an iframe
            fetchGuestToken: () => this.fetchGuestTokenFromBackend(),
            iframeSandbox: "allow-scripts allow-same-origin", // jei reikia, pridėk: 'allow-scripts allow-same-origin'
            dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional), urlParams (optional)
                hideTitle: true,
                filters: {
                    expanded: true,
                },
            },
            // You can handle other events like 'error', 'dashboard_loaded', etc.
            iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox']
            });
            this.findIframe();
        },
       async fetchGuestTokenFromBackend() {
            try {
                const response = await axios.post(`${this.$store.state.api_link}/superset/guest-token`, {
                    dashboard_id: '24a09e47-beee-4bbc-af05-fe531586a82c', // the dashboard ID you want to embed
                }, this.$store.getters.axiosConfig());
                if (response.data && response.data.token) {
                    return response.data.token;
                } else {
                    throw new Error("Token not found in backend response");
                }
            } catch (error) {
                console.error("Error fetching guest token from Laravel backend:", error.response ? error.response.data : error.message);
                let errorMessage = "Failed to fetch guest token.";
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
                throw new Error(errorMessage);
            }
        },
        findIframe() {
            if (this.$refs.dashboard) {
                // The iframe should be the first child, or you might need a more specific selector
                this.supersetIframe = this.$refs.dashboard.querySelector("iframe");
                console.log("Superset iframe found:", this.supersetIframe);
                if (this.supersetIframe) {
                let vm = this;
                console.log("Superset iframe element found:", this.supersetIframe);
                    window.addEventListener("message", (event) => {
                        if (event.origin === "https://dashboards.lkakademija.lt") {
                            console.log("Received message from Superset iframe:", event.data);
                            if(event.data.type == 'ROW_CLICK' && event.data.data && event.data.data.cell && (event.data.data.cell.column == 'info_button')) {
                                // alert('Row clicked in Superset dashboard with data: ' + JSON.stringify(event.data));
                                console.log("Row clicked in Superset dashboard with data:", event.data.data.row);
                                vm.openUserSide(event.data.data.row);
                            }
                            // Handle the message from the iframe here
                        }
                    });
                } else {
                    console.warn("Could not find Superset iframe within mountPoint after embedding.");
                }
            }
        },
        openUserSide(user) {
            console.log("Opening user side with data:", user);
            this.getUserInfo(user);
            this.userSideOpen = true;
        },
        getDocuments() {
            axios
                .get(
                `${this.$store.state.api_link}/documents`,
                this.$store.getters.axiosConfig()
                )
                .then((response) => {
                this.documents = response.data.data;
                })
                .catch((error) => {});
        },
        getUserInfo(user) {
            axios
                .post(
                `${this.$store.state.api_link}/user/find`,
                {
                    user: user,
                },
                this.$store.getters.axiosConfig()
                )
                .then((response) => {
                this.selectedUser = response.data.data;
                })
                .catch((error) => {});
        },
    }
}
</script>

<style lang="scss">
.superset-embed-container{
    width: 100%;
    height: calc(100vh - 11vh);
    overflow: hidden;
    iframe{
        width: 100%;
        height: 100%;
        border: none;
    }
}
</style>